// extracted by mini-css-extract-plugin
export var closeButton = "_qd-2";
export var closeButtonIcon = "_qd-3";
export var lightboxContent = "_qd-1";
export var lightboxOverlay = "_qd-0";